<template>
    <div class="date-inputs-container">
        <div class="date-input-wrapper">
            <h5>{{ label }}</h5>
            <md-field class="date-field">
                <md-datepicker v-model="date" md-immediately :md-debounce="100"></md-datepicker>
            </md-field>
        </div>
    </div>
</template>

<script>
import moment from 'moment';

export default {
    name: 'DateRangeFilter',
    props: {
        id: {
            type: String,
            required: true
        },
        label: {
            type: String,
            default: 'Date'
        },
        defaultValue: {
            type: String,
            default: () => moment().format('YYYY-MM-DD')
        },
        currentFilterValue: {
            type: String,
            default: () => moment().format('YYYY-MM-DD')
        }
    },
    data() {
        return {
            date: this.defaultValue
        };
    },
    watch: {
        date(newValue) {
            this.emitChange();
        }
    },
    methods: {
        emitChange() {
            this.$emit('change', {
                id: this.id,
                value: this.date,
                component: 'DateRangeFilter'
            });
        },
        reset() {
            this.date = this.currentFilterValue;
            this.emitChange();
        }
    }
};
</script>

<style scoped>
.date-inputs-container h5 {
    margin-top: 0;
    margin-bottom: 0px;
    font-weight: 500;
}

.date-range {
    display: flex;
    flex-direction: row;
    gap: 10px;
    justify-content: space-between;
}

.date-input {
    flex: 1;
}

.date-input label {
    display: block;
    font-size: 12px;
    margin-bottom: 5px;
    color: rgba(0, 0, 0, 0.54);
}

@media (max-width: 480px) {
    .date-range {
        flex-direction: column;
    }
}

.date-field {
    margin: 0 !important;
    padding: 0 !important;
    min-height: auto !important;
}

.date-inputs-container {
    display: flex !important;
    flex-direction: row !important;
    justify-content: space-between !important;
    width: 100% !important;
    gap: 20px !important;
    margin-bottom: 10px;
}

.date-input-wrapper {
    flex: 1 !important;
    min-width: 0 !important;
}
</style>
